<template>
  <div class="">
    <!-- 图片切换 -->
    <!-- <div class="box-1 box box-column-center box-between">
      <el-button :loading="loading" @click="prev">上一张</el-button>
      <span>{{ currentIndex + 1 }}/{{ images.length }}</span>
      <el-button :loading="loading" @click="next">下一张</el-button>
    </div> -->
    
    <!-- 工具按钮 -->
    <div class="box box-column-center box-between">
      <div class="tools box box-column-center box-1" style="background: #F6F7FA;padding: 0;margin-left: 10px;">
        <img :src="tool == 'rect' ? require(`@/assets/image/img/img-rect.svg`) : require(`@/assets/image/img/img-rect.png`)" class="pointer" @click="setTool('rect')"></img>
        <img :src="tool == 'circle' ? require(`@/assets/image/img/img-circle.svg`) : require(`@/assets/image/img/img-circle.png`)" class="pointer" @click="setTool('circle')"></img>
        <img :src="tool == 'line' ? require(`@/assets/image/img/img-line.svg`) : require(`@/assets/image/img/img-line.png`)" class="pointer" @click="setTool('line')"></img>
        <img :src="tool == 'text' ? require(`@/assets/image/img/img-text.svg`) : require(`@/assets/image/img/img-text.png`)" class="pointer" @click="setTool('text')"></img>
        <img :src="tool == 'back' ? require(`@/assets/image/img/img-back.svg`) : require(`@/assets/image/img/img-back.png`)" class="pointer" @click="back('back')"></img>
      </div>
      <div class="box box-column-center p-10">
        <el-button
        style="font-size: 16px"
        @click="cancel"
        :loading="loading"
        >
          取消
        </el-button>
        <el-button
        style="font-size: 16px;"
        @click="submit"
        :loading="loading"
        type="primary">
          保存
        </el-button>
      </div>
    </div>

    <!-- 画布容器 -->
    <div class="box box-center mb-10">
      <canvas ref="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
    </div>

    <!-- <div class="box box-column-center mb-20">
      <span>指标名称：</span>
      <el-select v-model="indexName" :disabled="loading" placeholder="请选择" style="width: 300px;" size="small" @change="changeIndexName">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.zbmc"
          :value="item.id">
        </el-option>
      </el-select>
    </div> -->

    
  </div>
</template>

<script>
const fabric = require('fabric');
import { FabricImage } from 'fabric';
import { uploadFile } from "@/api/block.js";
import moment from "moment";
import Compressor from "compressorjs";
import {
  indexPage
} from "@/api/base.js";
export default {
  props: {
    currentClockItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // 指标名称
      indexName: '',
      // 指标名称数组
      options: [
        {
          zbmc: '1',
          id: 1
        },
        {
          zbmc: '2',
          id: 2
        },
        {
          zbmc: '3',
          id: 3
        },
        {
          zbmc: '4',
          id: 4
        }
      ],
      canvas: null,
      tool: 'rect', // 当前工具：rect（矩形）、circle（圆形）、line（箭头）、text（文字）
      images: [], // 图片列表
      currentIndex: 0,
      imageObj: null,
      canvasWidth: 700,
      canvasHeight: 600,
      fileJson: [],
      loading: false,
      isEdit: false,

      // 其他原有属性...
      arrowStart: { x: 0, y: 0 }, // 箭头起点
      arrowEnd: { x: 0, y: 0 },   // 箭头终点
      isDrawingArrow: false,     // 是否正在绘制箭头
      tempArrowParts: []         // 存储临时箭头的线段（方便清除）
    };
  },
  mounted() {
    // this.images = this.currentClockItem.fileJson && JSON.parse(this.currentClockItem.fileJson).length ? JSON.parse(this.currentClockItem.fileJson).map(item => item.url) : [];
    // this.fileJson = this.currentClockItem.fileJson && JSON.parse(this.currentClockItem.fileJson).length ? JSON.parse(this.currentClockItem.fileJson) : [];
    this.images = this.currentClockItem && this.currentClockItem.url ? [this.currentClockItem.url] : [];
    if (!this.images.length) return false;

    // 得出当前指标名称列表，切换图片都要调
    this.getEveryItem();

    // 初始化画布
    this.canvas = new fabric.Canvas(this.$refs.canvas, {
      preserveObjectStacking: true,
    });
    // 加载初始图片
    this.loadImage(this.images[this.currentIndex]);
    // 监听画布绘制事件
    this.canvas.on('mouse:down', this.handleMouseDown);
    this.canvas.on('mouse:move', this.handleMouseMove);
    this.canvas.on('mouse:up', this.handleMouseUp);
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('cancel');
    },
    // 提交
    submit () {
      if (this.isEdit) {
        this.loading = true;
        this.toDataURL(1);
      } else {
        this.$emit('endEditPic');
      }
    },
    // 切换指标名称
    changeIndexName () {
      this.isEdit = true;
    },
    // 得每一处的数据并得出indexName
    getEveryItem () {
      // 得出当前指标名称列表，切换图片都要调
      // 并得出第一个indexName
      // this.eventPageFun();
      // 不调了现在 ，放外面处理
      // this.indexName = this.fileJson[this.currentIndex] && this.fileJson[this.currentIndex].indexName || this.currentIndex+1;
    },
    // 指标名称列表
    // async eventPageFun() {
    //   let params = {
    //     zbmc: "",
    //     ghEventManageId: this.currentClockItem.sourceMangerId || '',
    //     page: 1,
    //     size: 9999,
    //   };
    //   const res = await indexPage(params);
    //   if (res.data.code == 200) {
    //     this.options = res.data.data.records
    //       ? res.data.data.records
    //       : [];
    //   }
    // },
    // 加载图片
    loadImage(url) {
      FabricImage.fromURL(url).then((img) => {
      console.log(`----img原始尺寸----：${img.width}x${img.height}`)
      this.imageObj = img;
      this.canvas.clear();

      // 定义Canvas的宽高（假设你的canvasWidth和canvasHeight已定义）
      const canvasWidth = this.canvasWidth;
      const canvasHeight = this.canvasHeight;

      // 计算宽度和高度的缩放比例
      const scaleX = canvasWidth / img.width;
      // const scaleY = canvasHeight / img.height;

      // 取最小的缩放比例，保证图片完整显示在Canvas内
      // const imgScale = Math.min(scaleX, scaleY);

      img.set({
        top: 0,
        left: 0,
        scaleX: scaleX,
        scaleY: scaleX,
        originX: 'left',
        originY: 'top',
        selectable: false,   // 禁止选中底图
        evented: false,      // 底图不响应鼠标事件
        lockMovementX: true, // 锁定位置
        lockMovementY: true,
        zIndex: 0            // 确保在最底层
      });
      this.canvas.setWidth(canvasWidth);  // 让Canvas宽度与容器一致
      this.canvas.setHeight(img.height * scaleX); //  Canvas高度随图片缩放后的高度变化
      this.canvas.add(img);
      this.canvas.renderAll();
    }, {
      crossOrigin: 'anonymous'  // 跨域配置
    })
    },
    // canvas内容转换为图片数据
    toDataURL (val) {
      const dataURL = this.canvas.toDataURL('image/png');
      const file = this.dataURLtoFile(dataURL, 'annotated_image.png');
      // this.uploadFileFun(file, 'imageAnnotator', val)
      this.compressImage(file)
					.then((res) => {
						// console.log(`res:`, res)
							this.uploadFileFun(res, 'imageAnnotator', val);
					})
					.catch((err) => {});
    },
    compressImage(file) {
			return new Promise((resolve, reject) => {
				new Compressor(file, {
					quality: 0.6, // 压缩质量
					success: (result) => {
						// 创建一个新的File对象用于上传
						const newFile = new File([result], file.name, {
							type: "image/png",
						});
						resolve(newFile);
					},
					error: (error) => {
						console.log(error.message);
					},
				});
			});
		},
    async uploadFileFun(file, type, val) {
      // let formData = new FormData();
      // formData.append("file", file);
      // formData.append("objectName", type);
      // const res = await uploadFile(formData);
      // if (res.data.code === 200) {
      //   this.images[this.currentIndex] = `${process.env.VUE_APP_API_DOMAIN}/unified-code/file/download?filePath=${res.data.data.filePath}`;
      //   this.fileJson = {
      //     ...this.fileJson[this.currentIndex],
      //     indexName: this.indexName,
      //     url: this.images[this.currentIndex]
      //   }
      // }
      // this.loading = false;

      let formData = new FormData();
      formData.append("file", file);
      formData.append("objectName", type);
      this.$axios({
        method: "post",
        // url: `http://134.175.8.70:9299/dev-zgc-api-gw/unified-code/file/uploadFile`,
        // 测试服要放开根据环境来取路径
        url: `${process.env.VUE_APP_API_DOMAIN}/unified-code/file/uploadFile`,
        data: formData
      })
        .then(res => {
          if (res.data.code === 200) {
            // this.images[this.currentIndex] = `http://134.175.8.70:9299/dev-zgc-api-gw/unified-code/file/download?filePath=${res.data.data.filePath}`;
            // 测试服要放开根据环境来取路径
            this.images[this.currentIndex] = `${process.env.NODE_ENV == 'production' ? 'https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=' : 'http://134.175.8.70:9299/dev-zgc-api-gw/unified-code/file/download?filePath='}${res.data.data.filePath}`;
            // this.fileJson.forEach((item, index) => {
            //   if (index == this.currentIndex) {
            //     item.indexName = this.indexName;
            //     item.url = this.images[this.currentIndex];
            //     item.isEdit = true;
            //   }
              if (val && val == 1) {
                this.isEdit = false;
                this.$emit('endEditPic', {
                  // auditFilejson: JSON.stringify(this.fileJson)
                  url: this.images[this.currentIndex],
                  filePath: res.data.data.filePath
                })
              }
            // })
          }
          this.loading = false;
          this.isEdit = false;
        })
        .catch(() => {
          this.loading = false;
          this.isEdit = false;
        });
    },
    // 将DataURL转化为File对象
    dataURLtoFile(dataurl, filename = '标注图片') {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // 切换工具
    setTool(tool) {
      if (this.loading) return false;
      this.tool = tool;
    },
    // 鼠标按下事件
    handleMouseDown(e) {
      if (this.loading) return false;
      if (!e.target) {
        this.startX = e.e.offsetX;
        this.startY = e.e.offsetY;
        if (this.tool === 'text') {
          // 文字工具：点击处添加文字
          const text = new fabric.Textbox('输入文字', {
            left: this.startX,
            top: this.startY,
            width: 100,
            editable: true,
            borderColor: '#FF0000',
            cornerColor: '#FF0000',
            fill: '#FF0000'
          });
          this.canvas.add(text);
          this.isEdit = true;
        }
        if (this.tool === 'line') {
          // 重置起点为当前鼠标坐标
          this.arrowStart.x = e.e.offsetX;
          this.arrowStart.y = e.e.offsetY;
          this.isDrawingArrow = true;
          this.tempArrowParts = []; // 清空上一次的临时线段
        }
      }
    },
    // 鼠标移动事件（绘制图形时实时显示）
    handleMouseMove(e) {
      if (this.loading) return false;
      if (this.startX && this.startY && !e.target) {
        const currentX = e.e.offsetX;
        const currentY = e.e.offsetY;
        if (this.tempShape) {
          this.canvas.remove(this.tempShape);
        }
        if (this.tool === 'rect') {
          // 矩形
          this.tempShape = new fabric.Rect({
            left: Math.min(this.startX, currentX),
            top: Math.min(this.startY, currentY),
            width: Math.abs(currentX - this.startX),
            height: Math.abs(currentY - this.startY),
            stroke: 'red',
            fill: 'rgba(255, 0, 0, 0.1)',
            strokeWidth: 2,
            selectable: true,
          });
        } else if (this.tool === 'circle') {
          // 圆形
          const radius = Math.sqrt(
            Math.pow(currentX - this.startX, 2) +
              Math.pow(currentY - this.startY, 2)
          );
          this.tempShape = new fabric.Circle({
            left: this.startX,
            top: this.startY,
            radius,
            stroke: '#FF0000',
            fill: 'rgba(0, 0, 0, 0)',
            strokeWidth: 2,
            selectable: true,
          });
        } else if (this.tool === 'line') {
          // // 箭头（简化：绘制线段，样式模拟箭头）
          // this.tempShape = new fabric.Line(
          //   [this.startX, this.startY, currentX, currentY],
          //   {
          //     // stroke: 'green',
          //     // strokeWidth: 2,
          //     // strokeLineCap: 'round',
          //     // strokeLineJoin: 'round',
          //     // selectable: true,

          //     // stroke: 'purple',
          //     // strokeWidth: 2,
          //     // fill: 'purple',
          //     stroke: 'red', // 箭头线条颜色设为红色
          //     strokeWidth: 2,
          //     fill: 'red', // 填充颜色也设为红色
          //     strokeLineCap: 'round',
          //     zIndex: 10,
          //     // 箭头配置
          //     hasBorders: false,
          //     hasControls: false
          //   }
          // );
          // // // 设置箭头
          // // this.tempShape.set({
          // //   arrowEnd: {
          // //       type: 'arrow',
          // //       angle: 30,
          // //       length: 15
          // //   }
          // // });
          // // 强制刷新箭头样式（针对部分版本兼容问题）
          // this.tempShape.setCoords();
          if (this.loading || !this.isDrawingArrow) return;

          // 步骤1：清除上一次的临时箭头
          this.tempArrowParts.forEach(part => this.canvas.remove(part));
          this.tempArrowParts = [];

          // 步骤2：记录当前终点
          this.arrowEnd.x = e.e.offsetX;
          this.arrowEnd.y = e.e.offsetY;

          // 步骤3：绘制临时主线
          const mainLine = new fabric.Line(
            [this.arrowStart.x, this.arrowStart.y, this.arrowEnd.x, this.arrowEnd.y],
            {
              stroke: 'red',
              strokeWidth: 2,
              selectable: false, // 临时对象不可选中
              evented: false,    // 不响应事件
              type: 'tempArrow'  // 标记为临时箭头线段
            }
          );
          this.canvas.add(mainLine);
          this.tempArrowParts.push(mainLine);

          // 步骤4：计算箭头斜边（几何逻辑）
          const dx = this.arrowEnd.x - this.arrowStart.x;
          const dy = this.arrowEnd.y - this.arrowStart.y;
          const length = Math.sqrt(dx * dx + dy * dy);
          if (length < 5) return; // 线段过短则不画箭头

          const unitX = dx / length;
          const unitY = dy / length;
          const arrowLength = 15;  // 箭头长度
          const arrowAngle = Math.PI / 6; // 箭头角度（30度）

          // 箭头第一个端点
          const arrow1X = this.arrowEnd.x - arrowLength * (unitX * Math.cos(arrowAngle) - unitY * Math.sin(arrowAngle));
          const arrow1Y = this.arrowEnd.y - arrowLength * (unitY * Math.cos(arrowAngle) + unitX * Math.sin(arrowAngle));
          // 箭头第二个端点
          const arrow2X = this.arrowEnd.x - arrowLength * (unitX * Math.cos(arrowAngle) + unitY * Math.sin(arrowAngle));
          const arrow2Y = this.arrowEnd.y - arrowLength * (unitY * Math.cos(arrowAngle) - unitX * Math.sin(arrowAngle));

          // 步骤5：绘制临时箭头的两条斜边
          const arrowLine1 = new fabric.Line(
            [this.arrowEnd.x, this.arrowEnd.y, arrow1X, arrow1Y],
            {
              stroke: 'red',
              strokeWidth: 2,
              selectable: false,
              evented: false,
              type: 'tempArrow'
            }
          );
          this.canvas.add(arrowLine1);
          this.tempArrowParts.push(arrowLine1);

          const arrowLine2 = new fabric.Line(
            [this.arrowEnd.x, this.arrowEnd.y, arrow2X, arrow2Y],
            {
              stroke: 'red',
              strokeWidth: 2,
              selectable: false,
              evented: false,
              type: 'tempArrow'
            }
          );
          this.canvas.add(arrowLine2);
          this.tempArrowParts.push(arrowLine2);

          this.canvas.renderAll(); // 强制重绘
        }
        if (this.tempShape && this.tool !== 'line') {
          this.canvas.add(this.tempShape);
          this.tempShape.setCoords();
          this.canvas.renderAll();
        }
      }
    },
    // 鼠标抬起事件（确认图形）
    handleMouseUp(e) {
      if (this.tool === 'line') {
        if (!this.isDrawingArrow) return;
        this.isDrawingArrow = false;
        
        // 步骤1：清除临时箭头
        this.tempArrowParts.forEach(part => this.canvas.remove(part));
        this.tempArrowParts = [];

        // 步骤2：绘制永久主线
        const mainLine = new fabric.Line(
          [this.arrowStart.x, this.arrowStart.y, this.arrowEnd.x, this.arrowEnd.y],
          {
            stroke: 'red',
            strokeWidth: 2,
            selectable: true // 永久对象可选中
          }
        );
        this.canvas.add(mainLine);

        // 步骤3：重新计算箭头斜边（同移动时逻辑）
        const dx = this.arrowEnd.x - this.arrowStart.x;
        const dy = this.arrowEnd.y - this.arrowStart.y;
        const length = Math.sqrt(dx * dx + dy * dy);
        if (length < 5) return;

        const unitX = dx / length;
        const unitY = dy / length;
        const arrowLength = 15;
        const arrowAngle = Math.PI / 6;

        const arrow1X = this.arrowEnd.x - arrowLength * (unitX * Math.cos(arrowAngle) - unitY * Math.sin(arrowAngle));
        const arrow1Y = this.arrowEnd.y - arrowLength * (unitY * Math.cos(arrowAngle) + unitX * Math.sin(arrowAngle));
        const arrow2X = this.arrowEnd.x - arrowLength * (unitX * Math.cos(arrowAngle) + unitY * Math.sin(arrowAngle));
        const arrow2Y = this.arrowEnd.y - arrowLength * (unitY * Math.cos(arrowAngle) - unitX * Math.sin(arrowAngle));

        // 步骤4：绘制永久箭头的两条斜边
        const arrowLine1 = new fabric.Line(
          [this.arrowEnd.x, this.arrowEnd.y, arrow1X, arrow1Y],
          {
            stroke: 'red',
            strokeWidth: 2,
            selectable: true
          }
        );
        this.canvas.add(arrowLine1);

        const arrowLine2 = new fabric.Line(
          [this.arrowEnd.x, this.arrowEnd.y, arrow2X, arrow2Y],
          {
            stroke: 'red',
            strokeWidth: 2,
            selectable: true
          }
        );
        this.canvas.add(arrowLine2);

        this.canvas.renderAll();
        this.isEdit = true; // 标记为已编辑
      }
      if (this.tempShape && (this.tool === 'rect' || this.tool === 'circle')) {
        this.canvas.add(this.tempShape);
        this.tempShape = null;
        this.startX = null;
        this.startY = null;
        this.isEdit = true;
      }
    },
    // 回退（撤销上一步操作）
    back(back) {
      if (this.loading) return false;
      if (this.canvas._objects.length > 1) { // 至少保留图片
        console.log(this.canvas._objects[this.canvas._objects.length - 1].type)
        // this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1]);
        // this.canvas.renderAll();
        if (this.canvas._objects[this.canvas._objects.length - 1].type === 'line') {
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1])
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1])
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1]);
        } else if (this.canvas._objects[this.canvas._objects.length - 1].type === 'rect') {
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1]);
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1])
        } else if (this.canvas._objects[this.canvas._objects.length - 1].type === 'circle') {
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1]);
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1])
        } else {
          this.canvas.remove(this.canvas._objects[this.canvas._objects.length - 1])
        }
      }
      this.tool = back;
      setTimeout(() => {
        this.tool = '';
      }, 100);
      this.isEdit = true;
    },
    // 上一张图片
    prev() {
      // 如果有动作就调
      if (this.isEdit) {
        this.loading = true;
        this.toDataURL();
      }
      if (!this.loading) {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.loadImage(this.images[this.currentIndex]);
        this.getEveryItem();
      }
    },
    // 下一张图片
    next() {
      // 如果有动作就调
      if (this.isEdit) {
        this.loading = true;
        this.toDataURL();
      }
      if (!this.loading) {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.loadImage(this.images[this.currentIndex]);
        this.getEveryItem();
      }
    },
  },
};
</script>

<style lang="less" scoped>
canvas {
  border: 1px solid #ccc;
  margin: 10px 0;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.box-end {
  justify-content: flex-end;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.p-10 {
  padding: 10px;
}
.border-top {
  border-top: 1px solid #EEEEEE;
}
.pointer {
  cursor: pointer;
  margin-right: 20px;
}
.active {
  position: relative;
}

/deep/ canvas {
  margin-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/mCheckInManage/dwdlClockList/ImageAnnotator.vue